import { __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default, { forwardRef } from 'react';
import ZigTableData from './ZigTableData.js';
import ZigTableRtkInfiniteQuery from './ZigTableRtkInfiniteQuery.js';
import ZigTableRtkFiniteQuery from './ZigTableRtkFiniteQuery.js';

var ZigTable = function (props, ref) {
    if ("data" in props)
        return React__default.createElement(ZigTableData, __assign({}, props));
    if ("useInfiniteQuery" in props)
        return React__default.createElement(ZigTableRtkInfiniteQuery, __assign({}, props, { ref: ref }));
    if ("useQuery" in props)
        return React__default.createElement(ZigTableRtkFiniteQuery, __assign({}, props, { ref: ref }));
    throw new Error("ZigTable should have either data or query prop");
};
var index = forwardRef(ZigTable);

export { index as default };
